import { serviceBase } from "../service";

const DocumentTypeServise = {
  ...serviceBase,
  preList: "",
  resource: "document-types",
  resourceRole: "document-type"
};
export default DocumentTypeServise;
